import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';
import { AppModuleUsageType } from '@/models/enums';

export const modulesService = { getModulesTariffs, activateFreeModule, getUserModules };

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'modules'
};

function extract(r) {
  return r.data;
}

function getModulesTariffs(
  modulesIds: Array<number> | null = null,
  moduleTariffTypeId: number | null = null
) {
  let query = '';
  if (modulesIds && modulesIds.length > 0) {
    query = `?${modulesIds?.map(id => `mIds=${id}`).join('&')}`;
  }
  if (moduleTariffTypeId != null && !isNaN(moduleTariffTypeId)) {
    const delimiter = query.length > 0 ? '&' : '?';
    query = `${query}${delimiter}moduleTariffTypeId=${moduleTariffTypeId}`;
  }
  return axios
    .get(`${model.baseUrl}${model.controller}/tariffs${query}`)
    .then(extract);
}

function activateFreeModule(moduleTariffId: number) {
  return axios
    .post(`${model.baseUrl}${model.controller}/tariffs/${moduleTariffId}/activate`)
    .then(extract);
}

function getUserModules(moduleUsageType: AppModuleUsageType) {
  return axios
    .get(`${model.baseUrl}${model.controller}/user?moduleUsageType=${moduleUsageType}`)
    .then(extract);
}
